/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Jaroslav Přibyl (pribyl@cadwork.cz)
 *
 */

import {booleanLiteral} from "babel-types";

export enum eDownloadQueryState {
    NOTSCHEDULED = 0,
    SCHEDULED = 1,
    FAILED = 2,
    ABORTED = 3,
    FINISHED = 4
}

export default
class DownloadQuery {
    private _state: eDownloadQueryState;
    private _ajaxRequests: any[];
    private _keepDownloadSlot: boolean;

    constructor(aUrls: string[]) {
        this._state = eDownloadQueryState.NOTSCHEDULED;
        this._ajaxRequests = [];

        let urlsToDownload = aUrls.slice();

        let creteAjaxRequest = (aUrl: string) => {
            let request: any = {
                url: aUrl,
                xhr: null,
                data: null,
                onLoad: null,
                failed: false
            };

            let getAllRequestsFinished = () => {
                let finished = true;
                for (let i = 0; i < this._ajaxRequests.length; i++) {
                    finished = finished && this._ajaxRequests[i].buffer !== null;
                }
                return finished;
            };

            request.onLoad = () => {
                if (request.xhr.status === 200) {
                    request.buffer = request.xhr.response;
                    request.xhr = null;

                    if (getAllRequestsFinished()) {
                        this._state = eDownloadQueryState.FINISHED;
                    }
                } else if (request.xhr.status === 404) { // not found
                    this._state = eDownloadQueryState.FAILED;
                }
            };

            return request;
        };

        for (let i = 0; i < urlsToDownload.length; i++) {
            this._ajaxRequests.push(creteAjaxRequest(urlsToDownload[i]));
        }

        this._keepDownloadSlot = false;
    }

    public getState(): eDownloadQueryState {
        return this._state;
    }

    public download() {
        let request = null;
        for (let i = 0; i < this._ajaxRequests.length; i++) {
            request = this._ajaxRequests[i];

            request.xhr = new XMLHttpRequest();
            request.xhr.open("GET", request.url, true);
            request.xhr.responseType = "arraybuffer";
            request.xhr.addEventListener('load', request.onLoad.bind(this));
            request.xhr.send(null);
        }

        this._state = eDownloadQueryState.SCHEDULED;
    }

    public setKeepDownloadSlot(aValue: boolean) {
        this._keepDownloadSlot = aValue;
    }

    public getKeepDownloadSlot(): boolean {
        return this._keepDownloadSlot;
    }

    public abortDownload() {
        if (this._state === eDownloadQueryState.SCHEDULED) {
            for (let i = 0; i < this._ajaxRequests.length; i++) {
                if (this._ajaxRequests[i].xhr) {
                    this._ajaxRequests[i].xhr.abort();
                }
                this._ajaxRequests[i].buffer = null;
            }

            this._state = eDownloadQueryState.ABORTED;
        }
    }

    public getData() {
        return {
            type: "geo+jpg",
            data: this._ajaxRequests.slice()
        };
    }
}
